import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import HttpService from '../services/HttpServices';
import { toast } from 'react-hot-toast';
const apiService = HttpService;

// Initial state of the slice
const initialState = {
  myProfileData: [], 
  myProfileCertificateData: [],
  addCertificateList: [],
  addCertificateIssuingList: [],
  updateMyProfileData: [],
  loading: false,
  error: null,
};

export const fetchMyProfileData = createAsyncThunk(
  'myProfile/fetchMyProfileData',
  async (url, thunkAPI) => { // Accept URL instead of companyId
    try {
      const response = await apiService.get(url); // Use the URL directly
      return response;
    } catch (error) {
      console.log("error : ", error);
      return thunkAPI.rejectWithValue(error.response.data || error.message);
    }
  }
);

export const fetchMyProfileCertificateDetails = createAsyncThunk(
  'myProfile/fetchMyProfileCertificateDetails',
  async ({ companyId, queryParams }, thunkAPI) => {
    try {
      const response = await apiService.get(`/companies/${companyId}`,
        { params: queryParams }); // Use the URL directly
      return response;
    } catch (error) {
      console.log("error : ", error);
      return thunkAPI.rejectWithValue(error.response.data || error.message);
    }
  }
);

// Async thunk for Delete certificate
export const deleteMyProfileCertificateById = createAsyncThunk(
  'myProfile/deleteMyProfileCertificateById',
  async (certficateId, { rejectWithValue }) => {
    try {
      const response = await apiService.delete(`/companies/certificate/${certficateId}`);
      return response
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// update my profile details
export const editMyProfileDetails = createAsyncThunk(
  'myProfile/editMyProfileDetails',
  async ({ editedMyProfileData }, { rejectWithValue }) => {
    try {
      const url = `/companies/${editedMyProfileData.companyId}`;
      const response = await apiService.put(url, editedMyProfileData); // put
      // toast.success(response.data.msg);
      return response.data; //   your API returns the updated order data
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// update my profile certificate details
export const updateMyProfileCertificate = createAsyncThunk(
  'myProfile/updateMyProfileCertificate',
  async ({ editedMyProfileCertificateData }, { rejectWithValue }) => {
    try {
      const url = `/companies/update-certificate`;
      const response = await apiService.put(url, editedMyProfileCertificateData); // put
      return response.data; //   your API returns the updated order data
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// create my profile certificate 
export const createMyProfileCertificate = createAsyncThunk(
  'myProfile/createMyProfileCertificate',
  async ({ createMyProfileCertificate }, { rejectWithValue }) => {
    try {
      const url = `/companies/upload-certificate`;
      const response = await apiService.post(url, createMyProfileCertificate); // put
      return response.data; //   your API returns the updated order data
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

//fetch certificate list for add certificate
export const fetchCertificateList = createAsyncThunk(
  'myProfile/fetchCertificateList',
  async (queryParams, thunkAPI) => {
    try {
      const response = await apiService.get('/companies/cert-list?type=certificates');
      return response.data;
    } catch (error) {
      console.log("error : ", error)
      return thunkAPI.rejectWithValue(error.response.data || error.message);
    }
  }
);

//fetch certificate issuing bodies list for add certificate
export const fetchCertificateIssuingBody = createAsyncThunk(
  'myProfile/fetchCertificateIssuingBody',
  async (queryParams, thunkAPI) => {
    try {
      const response = await apiService.get('/companies/cert-list');
      return response.data;
    } catch (error) {
      console.log("error : ", error)
      return thunkAPI.rejectWithValue(error.response.data || error.message);
    }
  }
);

export const myProfileSlice = createSlice({
  name: 'myProfile',
  initialState,
  reducers: {
    resetMyProfileSlice: (state) => {
      state.myProfileData = [];
      state.myProfileCertificateData = [];
      state.addCertificateList = [];
      state.addCertificateIssuingList = [];
      state.updateMyProfileData = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handling fetch My Profile data
      .addCase(fetchMyProfileData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMyProfileData.fulfilled, (state, action) => {
        state.loading = false;
        state.myProfileData = action.payload.data.data[0];
      })
      .addCase(fetchMyProfileData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Handling fetch my profile certificate data
      .addCase(fetchMyProfileCertificateDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMyProfileCertificateDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.myProfileCertificateData = action.payload.data.data;
      })
      .addCase(fetchMyProfileCertificateDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //  Delete my profile certificate by id
      .addCase(deleteMyProfileCertificateById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteMyProfileCertificateById.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(deleteMyProfileCertificateById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editMyProfileDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMyProfileDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.updateMyProfileData = action.payload;
      })
      .addCase(editMyProfileDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCertificateList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCertificateList.fulfilled, (state, action) => {
        state.loading = false;
        state.addCertificateList = action.payload.data;
      })
      .addCase(fetchCertificateList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCertificateIssuingBody.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCertificateIssuingBody.fulfilled, (state, action) => {
        state.loading = false;
        state.addCertificateIssuingList = action.payload.data;
      })
      .addCase(fetchCertificateIssuingBody.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateMyProfileCertificate.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateMyProfileCertificate.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateMyProfileCertificate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createMyProfileCertificate.pending, (state) => {
        state.loading = true;
      })
      .addCase(createMyProfileCertificate.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createMyProfileCertificate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

// Export actions and reducer
export const { resetMyProfileSlice } = myProfileSlice.actions;
export default myProfileSlice.reducer;
